import { render, staticRenderFns } from "./TextSelect.vue?vue&type=template&id=dbeaabe4&"
import script from "./TextSelect.vue?vue&type=script&lang=js&"
export * from "./TextSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports